import type { FC } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import Skeleton from '@material-ui/lab/Skeleton'

export const headCells: any = [
  {
    id: 'name',
    label: 'User Name',
    sortable: true,
  },
  {
    id: 'job_title',
    label: 'Job Title',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'actions',
    label: 'Actions',
  },
]

interface IActionsCell {
  id: number
  handleDeleteUser: WidgetActionType
}
const ActionsCell: FC<IActionsCell> = ({ id, handleDeleteUser }) => {
  return (
    <div className="l-table__actionsCell">
      <Link
        className="l-table__link l-table__link--primary"
        to={`/edit-user/${id}`}
      >
        Edit
      </Link>
      <Link
        className="l-table__link l-table__link--primary"
        to={`/edit-user/${id}/permissions`}
      >
        <span className="l-table__link l-table__link--primary">
          Set Permissions
        </span>
      </Link>
      <span
        className="l-table__link l-table__link--delete"
        onClick={() => handleDeleteUser(id)}
      >
        Delete
      </span>
    </div>
  )
}

type WidgetActionType = (id: number) => void

function createData(
  user: any,
  handleGetUser: WidgetActionType,
  handleDeleteUser: WidgetActionType,
) {
  const { id, name, job_title, email } = user
  return [
    <React.Fragment key="id">{id}</React.Fragment>,
    <React.Fragment key="name">{name}</React.Fragment>,
    <React.Fragment key="job">{job_title}</React.Fragment>,
    <React.Fragment key="email">{email}</React.Fragment>,
    <ActionsCell key="actions" id={id} handleDeleteUser={handleDeleteUser} />,
  ]
}

export const createRows = (data: any, handleGetUser, handleDeleteUser) => {
  const rows: any = []

  if (!data || !Object.keys(data).length) {
    return rows
  }

  Object.keys(data).map((item: any) => {
    rows.push(
      createData({ id: item, ...data[item] }, handleGetUser, handleDeleteUser),
    )
  })
  return rows
}

export const createSkeletonRows = () =>
  Array(20)
    .fill('0')
    .map((_, idx) =>
      Array(7)
        .fill('0')
        .map((_, index) => {
          return <Skeleton key={`${idx}-${index}`} />
        }),
    )
